module.exports = __webpack_public_path__ + "static/media/sewer-system-fg.076ead6c.png";